@if(paymentInfo){
<div nz-row>
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'accountType']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Account Type
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.accountType ? paymentInfo?.accountType : '-' }}
      </div>
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'bankOrMoneyAppName']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Bank Or Money App Name
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.bankOrMoneyAppName ? paymentInfo?.bankOrMoneyAppName : '-' }}
      </div>
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'routingNumber']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Routing Number
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.routingNumber ? paymentInfo?.routingNumber : '-'}}
      </div>
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'accountNumber']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Account Number
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.accountNumber ? paymentInfo?.accountNumber : '-' }}
      </div>
    </div>
  </div>
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'optedOutOfPaperPaystubs']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Electronic Paystubs
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.optedOutOfPaperPaystubs ? "Yes" : 'No' }}
      </div>
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'paperCheck']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Paper Paychecks
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.paperCheck ? "Yes" : 'No' }}
      </div>
    </div>
  </div>
</div>
}@else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}